export class EdTabsHeaderOption {
  id: number;
  name: string;
  label: string;
  path: string;
  active: boolean;
  disabled: boolean;
  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.label = data.label;
    this.path = data.path;
    this.active = data.active ? data.active : false;
    this.disabled = data.disabled ? data.disabled : false;
  }
}